import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery_zn = () => {
  return (
    <React.Fragment>
      <SEO title="风景名胜 | DMBD 2024" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="风景名胜"
        content="For Participants"
        contentTwo="风景名胜"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <div className="ch-lang-ch">
            <Link className="btn btn-primary btn-hover-secondary  mt-s" to={process.env.PUBLIC_URL + "/scenery"}>English</Link>
          </div>
          <div className="space-50"></div>

          <h2>胡志明市的风景名胜</h2>

          <p align="justify">
            <b>
            胡志明市，原名西贡，是越南人口最多的城市。它位于该国南部，是一个重要的经济、文化和教育中心。这座城市以其充满活力的街头生活、熙熙攘攘的市场和反映其历史层次的独特建筑风格而闻名，从法国殖民时期的建筑到现代摩天大楼。
            <br></br>
            胡志明市也以其历史遗迹而闻名，包括战争遗迹博物馆，通过展览和展示，人们可以深入了解越南战争。另一个值得注意的地方是统一宫，它是1975年国家统一的象征。
            <br></br>
            这座城市的烹饪场景是美食爱好者的天堂，以各种美味的越南菜肴为特色，如越南河粉、越南越饭和新鲜的春卷。无论您是探索唐人街的狭窄小巷还是第一区的时尚咖啡馆和商店，胡志明市都为所有游客提供了充满活力和迷人的体验。        
            </b>
            <br />
          </p>

          <li>
            <a href="#War Remnants Museum">战争遗迹博物馆</a>
          </li>
          <li>
            <a href="#Saigon Opera House">西贡歌剧院</a>
          </li>
          <li>
            <a href="#Ho Chi Minh Square">胡志明广场</a>
          </li>
          <li>
            <a href="#Notre Dame Cathedral:">圣母大教堂 </a>
          </li>
          <li>
            <a href="#Central Post Office">胡志明市中央邮局</a>
          </li>
          <li>
            <a href="#Reunification Palace">统一宫</a>
          </li>
          <li>
            <a href="#Bitexco Financial Tower">比特斯科金融大厦</a>
          </li>

          <br />

          <hr></hr>
          <h4 id="War Remnants Museum">战争遗迹博物馆</h4>
          <p align="justify">
            战争遗迹博物馈提供了对越南战争（在地方上称为美国战争）影响的深刻反思。通过照片、军事装备和个人轶事的收藏，博物馆讲述了战争遗留下的故事及其对越南人民的长期影响。对于希望了解越南近代历史和人民的坚韧不拔的游客来说，这是一处必游之地。
          </p>
          <p>
            <img
              src="./images/xigong/war-remnants-museum.jpg"
              alt="War Remnants Museum"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Saigon Opera House">西贡歌剧院</h4>
          <p align="justify">
          西贡歌剧院，也称为市政剧院，是胡志明市心脏地带的法国殖民建筑典范。这座建于19世纪末的优雅建筑举办各种文化表演，包括歌剧、芭蕾舞和传统越南音乐舞蹈。其精美修复的内部和外观使其成为越南文化的象征和表演艺术的焦点。          
          </p>
          <p>
            <img
              src="./images/xigong/opera-house.jpg"
              alt="Saigon Opera House"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Ho Chi Minh Square">胡志明广场</h4>
          <p align="justify">
          胡志明广场是位于市中心的一个宽敞公共区域，是当地人和游客的热门聚集地。它被历史建筑和修剪整齐的花园所环绕，为胡志明雕像提供了风景如画的背景，这位备受敬仰的领导人是该市的命名者。广场经常举办节日和活动，是探索城市景点的绝佳起点。
          </p>
          <p>
            <img
              src="./images/xigong/ho-chi-minh-square.jpg"
              alt="Ho Chi Minh Square"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Notre Dame Cathedral">圣母大教堂</h4>
          <p align="justify">
          圣母大教堂，正式名称为无原罪圣母主教座堂，是法国殖民时期的建筑杰作。教堂全部使用从法国进口的材料建造，其双钟楼在城市天际线中矗立。尽管礼拜仪式使用越南语进行，教堂仍然是越南天主教信仰的象征，也见证了该国的殖民历史。
          </p>
          <p>
            <img
              src="./images/xigong/beautiful-cathedral.jpg"
              alt="Notre Dame Cathedral"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Central Post Office">胡志明市中央邮局</h4>
          <p align="justify">
          胡志明市中央邮局是该市的一个标志性地标，由著名建筑师古斯塔夫·埃菲尔设计。这座宏伟的建筑融合了哥特式和文艺复兴元素，至今仍作为一个全功能邮局运作。内部游客可以欣赏到精心保留的内饰，包括一幅历史老西贡的大地图，并可在这个城市最热门的旅游地点之一寄出明信片。
          </p>
          <p>
            <img
              src="./images/xigong/post-office-interior.jpg"
              alt="Central Post Office"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Reunification Palace">统一宫</h4>
          <p align="justify">
          统一宫，曾名独立宫，是越南战争结束时北越军队坦克冲破其大门的象征性地点。自那以后，宫殿几乎被保留成战时的样子，包括带有旧地图和通讯设备的战争指挥室。参观宫殿可以窥见南越政府在战争年代的生活。
          </p>
          <p>
            <img
              src="./images/xigong/the-independence-palace.jpg"
              alt="Reunification Palace"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Jiulong Waterfall">比特斯科金融大厦</h4>
          <p align="justify">
          比特斯科金融大厦是越南快速经济增长的象征，一度是胡志明市最高的建筑。这座68层的摩天大楼特色在于从49层延伸出的直升机停机坪，形似盛开的莲花。游客可以前往位于49层的西贡天际观景台，饱览城市全景，或在大厦内的现代设施中享受美食和购物。  
          </p>
          <p>
            <img
              src="./images/xigong/bitexco-financial-tower.jpg"
              alt="Bitexco Financial Tower"
              width="100%"
            />
          </p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery_zn;
